import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import raidenThumbnail from '../../assets/images/work/raiden/raiden_thumbnail.png';
import survey from '../../assets/images/work/raiden/raiden_graph.png';
import persona from '../../assets/images/work/raiden/persona.png';
import point_1 from '../../assets/images/work/raiden/raiden_point_1.png';
import point_2 from '../../assets/images/work/raiden/raiden_point_2.png';
import point_3 from '../../assets/images/work/raiden/raiden_point_3.png';
import OverView from '../../assets/images/work/raiden/raiden_overview.png';
import { ReactComponent as ExternalLinkIcon } from '../../assets/icons/external_link.svg';
import './raiden.css'; 
import '../SinglePost.css';

function Raiden() {
    // 見出し情報とアクティブな見出しを管理する状態
    const [headings, setHeadings] = useState([]);
    const [activeHeadingId, setActiveHeadingId] = useState(null);

    // コンテンツのDOMを参照するためのref
    const contentRef = useRef(null);

    // ① コンテンツを通常のJSXで記述
    const contentJSX = (
        <div>
            <div className="article-title-block">
                <h1 className="article-title">酒彩bar「RAIDEN」様 新規サイト提案</h1>
                <div className="article-sub-title"><strong>モバイルファーストのデザイン</strong></div>
            </div>
            
            <div className="article-info">
                <div className="use-tool">
                    <strong>使用ツール：</strong>Adobe Photoshop、Illustrator、Wordpress
                </div>
                <div className="product-period">
                    <strong>制作期間：</strong>2ヶ月
                </div>
            </div>

            <div className="thumbnail-block">
                <div>
                    <img 
                        src={raidenThumbnail} 
                        alt="酒彩bar『RAIDEN』のサムネイル画像。PCとスマホそれぞれのファーストビューの画像が表示されています。" 
                    /> 
                </div>  
            </div>

            <section className="overview">
                <h2>概要</h2>
                <div className="section-content">
                    <p>
                    今回の制作は、デザインスクールの卒業制作として酒彩bar「RAIDEN」様の新規サイト提案を行ったものです。本運用を前提としたサイトではなく、卒業制作の題材としてご協力いただいた形になります。近くに理系大学があり、男子大学生が約8割を占めることや、昔からの常連客が多いことなど、事前のアンケートを通じて得た客層の特徴やニーズを踏まえ、モバイルファーストのデザイン・情報設計を検討しました。特に貸切営業や店休日などの“今知りたい情報”を素早く把握できるようにトップページにお知らせを配置するとともに、本館と別館の位置関係や雰囲気の違いを視覚的に伝える工夫を行っています。
                    </p>
                </div>
                
            </section>

            <section className="task">
                <h2>現状・課題</h2>
                <div className="section-content">
                    <p>
                    現状を把握するために、来店した方たちに簡単なアンケートに答えていただきました。 
                    </p>

                    <figure>
                <img 
                    src={survey} 
                    alt="年齢層、男女比、来店数の円グラフが3つ横に並んでいます。" 
                />
                <figcaption>50名程度の来店客の集計結果です。</figcaption>
                </figure>
                <div className="list-block">
                    <p><strong>アンケート結果から以下の客層の特徴があることがわかりました。</strong></p>
                    <ul>
                        <li>近くに理系の大学があるため、客層はそこの<strong>男子学生が約8割</strong>を占める。</li>
                        <li>昔からの<strong>常連客が多い。</strong></li>
                    </ul>
                </div>
                
                <div className="list-block">
                    <p><strong>また、現在webサイトのような情報発信するものがないため、お客様側、お店側それぞれで以下の声が多く上がりました。</strong></p>
                    <ul>
                        <p className="list-sub-title"><strong>お客様の声</strong></p>
                        <li>お店の基本情報がわからない。</li>
                        <li>お店が不定休のため、電話か来店しないと営業しているのか確認することができない。</li>
                        <li>貸切の日があったりしたら、教えてほしい。（学生の打ち上げなどでよく貸切になるため）</li>
                    </ul>
                    <ul>
                        <p className="list-sub-title"><strong>従業員の声</strong></p>
                        <li>別館が最近できたため、忙しい時間帯だとお客さんを別館に案内するのが大変。</li>
                    </ul>

                </div>
                
                </div>  
                
            </section>  

            <section className="persona">
                <h2>ペルソナ</h2>
                <div className="section-content">
                    <div className="persona-block">
                        <div className="persona-img">
                        <img 
                            src={persona} 
                            alt="ペルソナのイメージ画像です。若い男性の画像が表示されています。" 
                        /> 
                        </div>
                        <div className="persona-info">
                            <h4 className="persona-title">居酒屋近くの大学に通う男子大学生</h4>
                            <p>
                            大学2年生。テニスサークルに所属。大学1年生の時は仲の良い友達2、3人で来店していた。 大学2年生になり、飲み会の回数が増え、サークルメンバー達と週1で来店している。<strong>サークルの打ち上げ場所は雷電でよく行われ、予約する係に任命されている。</strong>
                            </p>
                        </div>
                    </div>
                </div>     
            </section>   

            <section className="purpose">
                <h2>目的</h2>
                <div className="section-content">
                    <p>RAIDENの常連客がお店の最新情報をすぐ確認することができ、新規客にはお店の基本情報やマスターの魅力、RAIDENの楽しみ方を情報提供する。</p>
                </div>

            </section>

            <section className="point">
                <h2>デザインのポイント</h2>
                 <div className="section-content-wide">
                 <div className="point-container normal">
                    <div className="point-img"> 
                        <img 
                            src={point_1} 
                            alt="デスクトップの時のサイトの画像が表示されています。" 
                        />
                    </div>    
                    <div  className="point-description">
                    <h3>スプリットレイアウト</h3>
                        <p>学生はスマートフォンからサイトを閲覧する可能性が高いため、<strong>モバイルファーストなデザイン</strong>にしました。<strong>授業中や電車の中でも気軽にアクセスできます。</strong></p>
                    </div>
                </div>



                <div className="point-container reverse"> 
                    <div  className="point-description">
                        <h3>知りたい情報をすぐ見れる</h3>
                        <p><strong>ファーストビューにお知らせ情報を設置</strong>することで、常連客は貸切の日や店休日などすぐに知りたい情報にたどりつくことができます。</p>
                    </div>
                    <div className="point-img">    
                        <img 
                            src={point_2} 
                            alt="サイトで最初に表示されるところにお知らせ情報を載せている画像が表示されています。" 
                        /> 
                    </div>
                </div>


                <div className="point-container normal"> 
                    <div className="point-img">    
                        <img 
                            src={point_3} 
                            alt="本館と別館の案内を載せている画像が表示されています。" 
                        /> 
                    </div>
                    <div  className="point-description">
                        <h3>本館と別館の案内</h3>
                        <p>本館と別館は雰囲気が違うため、それぞれの店内の様子がわかるようにしました。また、<strong>本館と別館の位置関係を示すことで、従業員の方の案内の負担を減らす</strong>ようにしました。</p>
                    </div>
                </div>

                 </div>
                

            </section>


            <section class="overview">
                            <div>
                            <img 
                                src={OverView} 
                                alt="サイトの全体図が表示されています。" 
                            />
            
                            </div>
            
                        </section>

            <section className="summary">
                <h2>学んだこと</h2>
                <div className="section-content">
                    <p>今回のプロジェクトを通じて、利用者の行動やニーズを定量的・定性的に把握したうえでデザインへ落とし込むことの大切さを再認識しました。特に、スマートフォンが閲覧の中心となるターゲットには、限られたスペースでも見やすい情報レイアウトや操作性を追求する必要があると感じました。また、店舗と利用者の双方にメリットをもたらす機能を導入するためには、現場の声を聞き取り、実際の運用に役立つ導線を設計することが欠かせません。こうした視点を持つことで、情報発信だけでなく利用者とのコミュニケーションを円滑にする、より実用性の高いデザインの可能性が広がると学びました。</p>
                </div>
                

            </section>

            <section>
            <div className="section-content">
            <p>実際のサイトは、以下のリンクからアクセスできます。</p>
            <a  className="site-link"
                href="https://raiden.chiho-tsuda.com" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="酒彩bar「RAIDEN」の実際のサイトを新しいタブで開きます"
            >
                酒彩bar「RAIDEN」
                <ExternalLinkIcon className="external-link-icon" />
            </a>

            </div>

            </section>

        

        </div>
        
    );

    // ② コンテンツレンダリング後にrefから見出しを抽出する
  useEffect(() => {
    if (contentRef.current) {
      // querySelectorAllでh2, h3, h4タグを取得
      const headingEls = contentRef.current.querySelectorAll('h2, h3, h4');
      const extractedHeadings = [];
      headingEls.forEach((el, index) => {
        // IDがなければ自動で設定する
        if (!el.id) {
          el.id = `heading-auto-${index + 1}`;
        }
        // タグ名からレベルを数値として取得
        const level = parseInt(el.tagName.substring(1), 10);
        extractedHeadings.push({
          id: el.id,
          text: el.innerText,
          level: level,
        });
      });
      setHeadings(extractedHeadings);
    }
  }, []); // 一度だけ実行

  // ③ スクロールイベントでアクティブな見出しを更新（オプション）
  useEffect(() => {
    function handleScroll() {
      let currentActive = null;
      let minDistance = Infinity;
      headings.forEach(h => {
        const el = document.getElementById(h.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          const distance = Math.abs(rect.top);
          if (distance < minDistance) {
            minDistance = distance;
            currentActive = h.id;
          }
        }
      });
      setActiveHeadingId(currentActive);
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [headings]);

  // ④ クリック時に対象の見出しへスクロールする処理
  const handleClickHeading = (headingId) => {
    const el = document.getElementById(headingId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };


    return (
        <div className="single-post-container">
      
        <div className="single-post-main"> 
          <div className="back-to-home">
            <Link to="/" className="back-link">← Homeへ戻る</Link>
          </div>

          <div className="single-post-content" ref={contentRef}>
            {contentJSX}
          </div>

          <div className="back-to-home">
            <Link to="/" className="back-link">← Homeへ戻る</Link>
          </div>
        </div>
  
        <Sidebar
          headings={headings}
          activeHeadingId={activeHeadingId}
          onClickHeading={handleClickHeading}
        />
        
      </div>

    );

}
export default Raiden;  